import React from 'react';
import {
  FadeTransition,
  FlyInTransition,
} from '../../transitions/transitions';
import './SheetShell.css';

/**
 * Generic bottom-sheet shell. Single responsibility: backdrop + slide-up
 * animation + dismiss policy. Holds NO business logic — feature sheets
 * compose it and pass their content as children.
 *
 * Reuses the app-wide FlyInTransition / FadeTransition (index.css). Styled
 * with a plain CSS file — no inline styles, no styled-components.
 *
 * By default outside (backdrop) clicks do NOT close the sheet; opt in with
 * `closeOnOverlayClick`.
 */
export default function SheetShell({
  visible,
  onClose = undefined,
  closeOnOverlayClick = false,
  children = null,
  className = '',
  contentLabel = undefined,
}) {
  const handleOverlayClick = () => {
    if (closeOnOverlayClick && onClose) onClose();
  };

  return (
    <>
      <FadeTransition in={visible} timeout={300} mountOnEnter unmountOnExit>
        <div
          className="sheet-shell__overlay"
          onClick={handleOverlayClick}
          aria-hidden="true"
        />
      </FadeTransition>
      <FlyInTransition in={visible} appear timeout={200} mountOnEnter unmountOnExit>
        <div className="sheet-shell__container">
          <div
            className={`sheet-shell__panel${className ? ` ${className}` : ''}`}
            role="dialog"
            aria-modal="true"
            aria-label={contentLabel}
          >
            {children}
          </div>
        </div>
      </FlyInTransition>
    </>
  );
}
